import React from 'react';

import { Footer } from '../../components/Footer';
import Issue from './Issue';
import HeroHome from './HeroHome';
import Quote from './Quote';
// import contactimg from 'public/assets/img/contact/01.jpg'
function ContactUs() {
  return (
    <>
 
<HeroHome/>   
<Issue/>
<Quote/>
    <Footer/>
    </>
  );
}

export default ContactUs;